import React, { Component, Fragment } from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

import CustomEmptyMessage from "../../../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../../../../Components/CustomSiteLoader/CustomSiteLoader";
import CustomTableHead from "../../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import AddExamSubjects from "../AddExamSubjects/AddExamSubjects";
import ExamSubjectBody from "../ExamSubjectBody/ExamSubjectBody";

class ViewExamSubjects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editStatus: false,
      editIndex: "",
      editData: {
        name: "",
        date: "",
        startTime: "",
        endTime: "",
        fullMarks: 0,
        passMarks: 0,
      },
      customFunction: "",
      column: [
        { name: "S.N." },
        { name: "Subject Name" },
        { name: "Exam Date" },
        { name: "Start Time" },
        { name: "End Time" },
        { name: "Full Marks" },
        { name: "Pass Marks" },
        { name: "Actions" },
      ],
    };
  }

  handleEditStatus = (editIndex, data, customFunction) => {
    this.props.handleEditSubjectChange(data);
    this.setState({
      editStatus: true,
      editIndex,
      customFunction,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleEditSubmit = (editIndex, editData) => {
    this.props.handleEditSubject(editIndex, editData);
    this.state.customFunction();
  };

  render() {
    const {
      subjectData,
      subjects,
      subjectList,
      handleSubjectChange,
      handleSubjectSubmit,
      handleDeleteSubject,
      handleEditSubjectChange,
      subjectError,
    } = this.props;
    const isEmpty = this.props.subjects.length === 0 ? true : false;
    return (
      <Fragment>
        <div style={{ color: "#f00" }}>{subjectError}</div>

        <AddExamSubjects
          editStatus={this.state.editStatus}
          editIndex={this.state.editIndex}
          subjectList={subjectList}
          data={subjectData}
          handleSubjectChange={handleSubjectChange}
          handleSubjectSubmit={handleSubjectSubmit}
          handleEditSubject={this.handleEditSubmit}
          handleEditSubjectChange={handleEditSubjectChange}
          handleCancelEdit={this.handleCancelEdit}
        />
        <TableContainer>
          <Table>
            <CustomTableHead column={this.state.column} />
            {subjects.length !== 0 ? (
              <TableBody>
                {subjects.map((subject, index) => (
                  <ExamSubjectBody
                    key={index}
                    index={index}
                    subject={subject}
                    editStatus={this.state.editStatus}
                    handleDeleteSubject={handleDeleteSubject}
                    handleEditStatus={this.handleEditStatus}
                    handleCancelEdit={this.handleCancelEdit}
                  />
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={8}>
                    {isEmpty ? (
                      <CustomEmptyMessage description="Please enter subjects from above form" />
                    ) : (
                      <CustomSiteLoader />
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Fragment>
    );
  }
}

export default ViewExamSubjects;
